export default (props) => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
  <path
    d="M13.1109 2.0566C12.1109 1.29483 11.0021 1.08789 10.6324 1.59305L9.96585 2.50682L13.5862 5.26196L14.2541 4.34844C14.6225 3.84303 14.1116 2.81737 13.1109 2.0566Z"
    fill={props.fill || 'currentColor'}    
  />
  <path
    d="M2.60896 16.7576L6.4222 15.3933L2.80089 12.6374L2.60896 16.7576Z"
    fill={props.fill || 'currentColor'}    
  />
  <path
    d="M3.45103 11.7019L7.06396 14.375L12.9428 6.18526L9.32982 3.5122L3.45103 11.7019Z"
    fill={props.fill || 'currentColor'}    
  />
</svg>
);


